import Breadcrumbs from "components/common/Breadcrumbs";
import Text from "components/common/Text";
import CustomerDetail from "components/CustomerTable/CustomerDetail";
import React from "react";

class CustomerDetailContainer extends React.Component {
  componentDidMount() {
    const id = this.props.history.location.customerId;
    if (!id) {
      this.props.history.goBack();
    }
    this.props.getPersonalDetailAction({ id });
    this.props.getPhotosUploadedAction({ id });
    this.props.getReviewsAction({ id });
    this.props.getChargingStationsAction({ id });
  }

  render() {
    const history = this.props.history;

    const props = {
      personalDetailData: this.props.personalDetailData,
      photosUploaded: this.props.photosUploaded,
      reviews: this.props.reviews,
      chargingData: this.props.chargingData,
    };
    return (
      <>
        <Breadcrumbs>
          <Text onClick={() => history.goBack()} sx={{ cursor: "pointer" }}>
            
            Customers
          </Text>
          <Text
            sx={{
              fontSize: "14px",
            }}
            color="text.primary"
          >
            Customer Details
          </Text>
        </Breadcrumbs>

        <CustomerDetail props={props} />
      </>
    );
  }
}
export default CustomerDetailContainer;
